import { onMounted, ref, getCurrentInstance } from 'vue'

export default function () {
  const teamLevelTypeEnums = ref([])

  const { proxy } = getCurrentInstance()

  async function getLevelTypes() {
    const res = await proxy.$http({
      type: 'get',
      url: '/Team/getTeamLists',
      params: {
        page: 1,
        limit: 1000,
      },
    })
    if (res.code == 0) {
      teamLevelTypeEnums.value = [...res.data.data, { id: 0, title: '无配置' }]
    }
  }

  onMounted(() => {
    getLevelTypes()
  })

  function getTeamLevelName(id) {
    const temp = teamLevelTypeEnums.value.find((item) => id == item.id)
    if (temp) {
      return temp.title
    } else {
      return ''
    }
  }

  return { teamLevelTypeEnums, getTeamLevelName }
}
